document.addEventListener("DOMContentLoaded", function () {
  const sliderElement = document.querySelector('logo-section-slider');
  const isMarquee = sliderElement && sliderElement.getAttribute('data-marquee') === 'true';

  let swiperConfig = {
    slidesPerView: 2, 
    spaceBetween: 15,
    loop: true,
    breakpoints: {
      480: { slidesPerView: 3, spaceBetween: 20 },
      640: { slidesPerView: 3, spaceBetween: 30 },
      1024: { slidesPerView: 4, spaceBetween: 40 },
      1440: { slidesPerView: 5, spaceBetween: 50 },
      1540: { slidesPerView: 6, spaceBetween: 50 },
    }
  };

  if (isMarquee) {
    swiperConfig.speed = 3000;
    swiperConfig.autoplay = {
      delay: 0,
      disableOnInteraction: false,
    };
    swiperConfig.allowTouchMove = false;
  } else {
    swiperConfig.speed = 300;
    swiperConfig.autoplay = {
      delay: 2500,
      disableOnInteraction: false,
    };
    swiperConfig.pagination = {
      el: '.swiper-pagination',
      clickable: true,
    };
  }

  var swiper = new Swiper('.mySwiper3', swiperConfig);
});